let handler: (() => void) | null = null

export function setLexnetSessionExpiredHandler(fn: (() => void) | null): void {
  handler = fn
}

export function triggerLexnetSessionExpired(): void {
  handler?.()
}
